import React from 'react'
import { Grid } from '@mui/material'
import { useTranslate } from 'react-admin'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'

export const FlexiTab = ({ product, loading }) => {
  const translate = useTranslate()
  
  const productName = "Flexi"

  const rawAmount = product?.flexible_amount ?? "0"
  const formattedAmount = Number(rawAmount).toFixed(2)

  return (
    <Grid container spacing={2}>
      <ShowListElement
        sm={2}
        label="Producto"
        value={productName}
      />
      <ShowListElement
        sm={2}
        label="Monto"
        value={loading ? translate('ra.action.loading') : formattedAmount}
      />
    </Grid>
  )
}